import { isPublicExamPath } from '../features/examens/examChamberConstants';
import { resolveExamHostRoute } from '../features/examens/examHosts';
import { resolveFormationsRoute } from '../features/formations/formationsHosts';
import { resolvePortfolioRoute } from '../features/portfolio/utils/slug';
import { isMarketingPath } from '../features/marketing/MarketingShell';
import { resolveLandingRoute } from '../features/marketing/landings/resolveLandingRoute';

/** Public pages rendered outside the teacher shell (App.js branches, in render order). */
export const STANDALONE_PATH = Object.freeze({
  COLD_HANDS: /^\/story\/cold-hands(?:\/|$)/i,
  FAMILY: /^\/family(\/|$)/i,
  SHARED_MISSIONS: /^\/missions\/[0-9a-f-]{36}(\/|$)/i,
  PUBLIC_GAME: /^\/jouer\/[0-9a-f-]{36}(\/|$)/i,
  CALCUL: /^\/(calcul|activites)(\/|$)/i,
  PLACEMENT_TEST: /^\/test\/[a-z0-9-]+\/[a-z0-9èéêà-]+\/?$/i,
  VERIFY_INVOICE: /^\/verify\/invoice(\/|$)/i,
  LEGAL: /^\/(legal-mentions|privacy-policy|terms-of-service|terms-of-sale|avance-immediate|contact)(\/|$)/i,
  LESSONS: /^\/lessons(\/|$)/i,
  EXAM_SITTING: /^\/examens\/passer\//i,
  THEME_DEMO: /^\/theme-demo(\/|$)/i,
  PRODUCT_DEMO: /^\/demonstration(\/|$)/i,
  FEATURES: /^\/fonctionnalites(\/|$)/i,
  EDITORIAL: /^\/(blog|questions-frequentes|nos-valeurs|comparatif)(\/|$)/i,
  GROWTH_LANDING: /^\/l\/[a-z0-9-]+\/?$/i,
});

/** True when the page never shows the teacher shell, so teacher data must not be loaded. */
export function isStandalonePath({ hostname, pathname }) {
  return Object.values(STANDALONE_PATH).some((pattern) => pattern.test(pathname))
    || isMarketingPath(pathname, hostname)
    || Boolean(resolveLandingRoute({ hostname, pathname }))
    || isPublicExamPath(pathname)
    || Boolean(resolveExamHostRoute({ hostname, pathname }))
    || Boolean(resolveFormationsRoute({ hostname, pathname }))
    || Boolean(resolvePortfolioRoute({ hostname, pathname }));
}
